import React from 'react'
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import {InfoCircleOutlined } from '@ant-design/icons';

const VendorDashboard = () => {
    const { user } = useSelector((state) => state.userAuth);

    const isProfileComplete = () => {
        return (
            user?.first_name &&
            user?.last_name &&
            user?.phonenumber &&
            user?.avatar
        );
    };
    return (
        <div>
            {/* Profile Completion Banner */}
            {!isProfileComplete() && (
                <div className="mb-8 p-6 bg-gradient-to-r from-orange-50 to-orange-100 border-l-4 border-orange-500 rounded-lg shadow-sm">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-4">
                            <div className="">
                            <InfoCircleOutlined className="text-4xl text-orange-600" />
                            </div>
                            <div>
                                <h3 className="text-xl font-semibold text-gray-800">Complete Your Profile</h3>
                                <p className="text-gray-600 mt-1">
                                    Add your personal details to unlock all features
                                </p>
                            </div>
                        </div>
                        <Link
                            to="/setting"
                            className="px-6 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors shadow-md"
                        >
                            Complete Now
                        </Link>
                    </div>
                </div>
            )}
            
            <p>Welcome to the Dashboard!</p>
        </div>
    )
}

export default VendorDashboard
